// react-dropdown exports a CJS module with { default: Component }.
// This shim unwraps it so Triangle UI's `import Dropdown from 'react-dropdown'`
// resolves to the actual component function under the published package layout.
import DropdownModule from 'react-dropdown/dist/index'

const Dropdown = DropdownModule?.default || DropdownModule

export default Dropdown
